import { RichText } from "components/RichTextWidget";
import {
  Container,
  Heading3,
  Heading5,
  Icon,
  ImageLite,
  PageLink,
  Paragraph,
} from "shared/components";

import styles from "./Content043.module.scss";

export const Content043 = ({ payload }) => {
  const title = payload?.title ?? "";
  const subtitle = payload?.subtitle ?? "";
  const description = payload?.description ?? "";
  const image = payload?.preview ?? {};
  const { buttonText, link } = payload?.button ?? {};

  return (
    <div className={styles.wrapper}>
      <Container>
        <Heading3 className={styles.title}>{title}</Heading3>

        <div className={styles.content}>
          <span className={styles.preview}>
            <ImageLite image={image} className={styles.image} />
          </span>
          <div className={styles.about}>
            <Heading5 className={styles.subtitle}>{subtitle}</Heading5>
            <RichText value={description} className={styles.description} />
            <div className={styles.circle}>
              <PageLink link={link} className={styles.link}>
                <span className={styles.arrow}>
                  <Icon className={styles.icon} name="large_arrow_right" />
                </span>
                <Paragraph color="brand" appearance="bigger">
                  {buttonText}
                </Paragraph>
              </PageLink>
            </div>
          </div>
        </div>
      </Container>
    </div>
  );
};

export default Content043;
